<template>
  <span>
    <button class="button is-rounded is-small is-light tag-button">
      <b-icon
        v-if="status === 'active' || status === 'showroom'"
        icon="check-circle"
        type="is-success"
      ></b-icon>

      <b-icon
        v-else-if="status === 'inactive'"
        icon="exclamation-circle"
        type="is-warning"
      ></b-icon>

      <b-icon
        v-else-if="status === 'comingSoon'"
        icon="exclamation-circle"
        type="is-info"
      ></b-icon>

      <b-icon
        v-else-if="status === 'onMaintenance'"
        icon="exclamation-circle"
        type="is-dark"
      ></b-icon>

      &nbsp;&nbsp;
      {{
        `${
          status === "active"
            ? $t("dashboard.active")
            : status === "inactive"
            ? $t("dashboard.inactive")
            : status === "comingSoon"
            ? $t("dashboard.comingSoon")
            : status === "onMaintenance"
            ? $t("dashboard.underMaintenance")
            : status === "showroom"
            ? $t("dashboard.showroom")
            : "-"
        } ${vendingsOnly ? ` - ${$t("dashboard.vendingsOnly")}` : ""}`
      }}
    </button>
    &nbsp;
  </span>
</template>

<script>
export default {
  props: ["status", "vendingsOnly"]
};
</script>

<style scoped>
.tag-button {
  cursor: default;
  border: 1px solid #bbbbbb;
}
</style>
